import axios from "axios";
import config from "./src/api/env.js";
import Vue from "vue";
import router from './src/router'
import Element from "element-ui";
Vue.use(Element);

var request = axios.create({
  baseURL: config.baseURL,
});

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    console.log(res);
  
    if (res.data.result == "error") {
      if (res.data.status == 201) {
        console.log('123');
        return Element.Notification({
          title: "警告",
          message: res.data.msg || "失败",
          type: "warning",
        });
      } else if (res.data.status == 401) {
        Element.Notification({
          title: "警告",
          message: res.data.msg || "失败",
          type: "warning",
        });
        localStorage.removeItem("userdynamic");
        return location.reload();
      }
      Element.Notification({
        title: "警告",
        message: res.data.msg || "后台错误",
        type: "warning",
      });
      return;
    }
    if (res.status == 200) {
      return res.data;
    }
  },
  (error) => {
    if (error) {
      Element.Notification({
        title: "警告",
        message: "后台错误",
        type: "warning",
      });
    }
    return Promise.reject(error);
  }
);
// 请求拦截器
request.interceptors.request.use(
  (config) => {
    if (window.localStorage.getItem("iuId")) {
      config.headers.common["userid"] = window.localStorage.getItem("iuId");
    } else {
      console.log(config);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default request;
